(() => {
  function initReviewWall(wall) {
    const initial = parseInt(wall.dataset.hcInitial || wall.dataset.initial, 10) || 9;
    const step = parseInt(wall.dataset.hcStep || wall.dataset.step, 10) || 6;
    const moreWrap = wall.closest('.hc-review-wall')?.querySelector('[data-hc-more-wrap]');
    const moreBtn = wall.closest('.hc-review-wall')?.querySelector('[data-hc-more]');

    // Collect all cards in order (across all 3 columns)
    const allCards = Array.from(wall.querySelectorAll('[data-review-idx]'))
      .sort((a, b) => parseInt(a.dataset.reviewIdx) - parseInt(b.dataset.reviewIdx));

    let visible = 0;

    function show(count) {
      const next = Math.min(visible + count, allCards.length);
      allCards.forEach((card, i) => {
        if (i < next) {
          const wasHidden = card.hasAttribute('data-hidden');
          card.removeAttribute('data-hidden');
          if (wasHidden && i >= visible) {
            // stagger newly revealed cards
            card.style.animationDelay = `${(i - visible) * 60}ms`;
            card.setAttribute('data-animate-in', '');
            card.addEventListener('animationend', () => card.removeAttribute('data-animate-in'), { once: true });
          }
        } else {
          card.setAttribute('data-hidden', '');
        }
      });
      visible = next;
      if (moreWrap) {
        if (visible >= allCards.length) {
          moreWrap.setAttribute('data-hidden', '');
        } else {
          moreWrap.removeAttribute('data-hidden');
        }
      }
    }

    // Init — hide all first, then reveal initial batch
    allCards.forEach(c => c.setAttribute('data-hidden', ''));
    show(initial);

    moreBtn?.addEventListener('click', () => show(step));

    // External link detection: any link not pointing to this domain opens in new tab
    function applyExternalLinks() {
      wall.querySelectorAll('.hc-review-card__quote a').forEach(link => {
        try {
          const url = new URL(link.href, window.location.origin);
          if (url.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
          }
        } catch (e) { /* malformed URL — leave as-is */ }
      });
    }
    applyExternalLinks();

    // Shopify section reload
    wall.closest('[id]')?.addEventListener('shopify:section:unload', () => {});
  }

  document.querySelectorAll('[data-hc-review-wall]').forEach(initReviewWall);

  document.addEventListener('shopify:section:load', (e) => {
    const wall = e.target.querySelector('[data-hc-review-wall]');
    if (wall) initReviewWall(wall);
  });
})();
